export default __webpack_public_path__ + "static/media/image-earphones.6e8830d4.png";